import { Sparkles } from "lucide-react";

export const UrgencyStrip = () => (
    <div
        data-testid="urgency-strip"
        className="bg-[#2C2A29] px-4 py-2 text-center text-xs font-semibold uppercase tracking-[0.2em] text-[#D4AF37] sm:text-sm"
    >
        <span className="inline-flex items-center gap-2">
            <Sparkles className="h-3.5 w-3.5" />
            Limited wedding slots available — book your date now
        </span>
    </div>
);
